import React, { Fragment, useEffect, useState, useCallback, useRef, useDebugValue } from 'react';
import { Modal as BootstrapModal } from 'bootstrap';
import { useStatePersist } from 'use-state-persist';
import SortableList from './SortableList';
import { arrayMoveImmutable } from 'array-move';
import { ACCESS_KEY, DATE_FORMAT_LIST, USER_KEY } from '../constants/index';
import { isEmpty, filterByReference } from '../util/commonUtils';
import { DatePicker, Spin } from 'antd';

export const BulkTraitSelectionModal = (props: any) => {
  const impactRef21: any = useRef();
  const {
    handleToggleChangeMeasurement,
    show,
    setShow,
    options,
    SetCropsState,
    setValue,
    SetCallApi,
    growerValue,
    label,
    className,
    closeModal,
    id,
    onOkay,
    handleToggleChange,
    setOrderOfTrait,
    varieties,
    selectedTrials,
    traitStateSelectedMain,
    selectedYear,
    handleChangeMain,
    onChangeYear,
    dateWeekToggle,
    handleDateWeekToggleChange,
    selectedDateFormat,
    toggle,
    setReDraw,
    jRef,
    order,
    setOrder,
    selected,
    setSelected,
    setVarietiesOrder,
    setInitialValueOfOrder,
    setInitialValueOfOrder1,
    measurementType,
    setPrevTraits,
    prevTraits,
    traitsetList,
    getTraitList,
    selectedCrop,
    defaultTraitSet,
    setHasDateTrait,
    hasDateTrait,
    dropDownSelected,
    setDropDownSelected
  } = props;
  const [storeStateSelected, setStoreStateSelected]: any = useState([]);
  // const [selected, setSelected]: any = useState([])
  const [initalGrowerValue, setInitialGrowerValue]: any = useState([]);
  const [query, setQuery]: any = useState();
  const [cropSearchName, setCropSearchName] = useState('');
  let cropOptionsFiltered: any[] = [];
  const [currentStep, setCurrentStep] = useState(1);
  const [tempDropDownSelected, setTempDropDownSelected] = useState('');
  const [tempSelected, setTempSelected] = useState([]);
  const [isLoadingTraits, setIsLoadingTraits] = useState(false);

  function disabledDate(current: any) {
    // Disable dates after the current year
    return current && current.year() > new Date().getFullYear();
  }

  useEffect(() => {
    if (!show) return;

    const loadInitialTraits = async () => {
      setIsLoadingTraits(true);

      try {
        if (prevTraits?.length > 0 && tempDropDownSelected !== '') {
          setCurrentStep(1);
          setCropSearchName('');
          setQuery(options);

          const selectedArrayFiltered = filterByReference(options, prevTraits);

          const checked = selectedArrayFiltered.map((item: any) => ({
            ...item,
            selected: true
          }));

          setStoreStateSelected(checked);
          setTempSelected(checked);
          setTempDropDownSelected(dropDownSelected);
        } else {
          let dropVal = '';
          if (defaultTraitSet == null) {
            dropVal = 'Select Trait Set';
            const formDataForTrait = {
              DefaultTraitSetID: 0,
              cropCode: selectedCrop?.cropCode
            };
            await getTraitList(formDataForTrait);
          } else {
            const traitFromDefaultFieldSet = traitsetList?.find(
              (item: any) => item?.fieldSetID === defaultTraitSet
            );
            if (traitFromDefaultFieldSet) {
              dropVal = traitFromDefaultFieldSet?.fieldSetName;
              const formDataForTrait = {
                DefaultTraitSetID: traitFromDefaultFieldSet?.fieldSetID,
                cropCode: selectedCrop?.cropCode
              };
              await getTraitList(formDataForTrait);
            }
          }

          const selectedArrayFiltered =
            prevTraits?.length > 0 ? filterByReference(options, prevTraits) : [];

          setCurrentStep(1);
          setCropSearchName('');
          setQuery(options);

          const checked = selectedArrayFiltered.map((item: any) => ({
            ...item,
            selected: true
          }));
          setStoreStateSelected(checked);
          setTempSelected(checked);
          setTempDropDownSelected(dropVal);
        }
      } finally {
        setIsLoadingTraits(false);
      }
    };

    loadInitialTraits();
  }, [show]);

  useEffect(() => {
    if (!show) return;

    const selectedArrayFiltered =
      prevTraits?.length > 0 ? filterByReference(options, prevTraits) : [];

    setCurrentStep(1);
    setCropSearchName('');
    setQuery(options);

    if (selectedArrayFiltered.length > 0) {
      const checked = selectedArrayFiltered.map((item: any) => ({
        ...item,
        selected: true
      }));
      setStoreStateSelected(checked);
      setSelected(checked);
      setValue(prevTraits);
    } else {
      setSelected([]);
      setStoreStateSelected([]);
      setValue(prevTraits);
    }
  }, [options, show]);

  const selectedChanges = (data: any) => {
    let updatedSelected: any = [];
    const checkIfDataExist = tempSelected.filter(
      (item: any) => item.traitID === data?.traitID && item.selected === true
    );

    if (checkIfDataExist.length > 0) {
      const filtered = tempSelected.filter((item: any) => item.traitID !== data.traitID);
      updatedSelected = filtered.map((item: any) => ({
        ...item,
        selected: true
      }));
      setTempSelected(updatedSelected);
    } else {
      updatedSelected = [...tempSelected, { ...data, selected: true }];
      setTempSelected(updatedSelected);
    }
  };

  useEffect(() => {
    if (!dateWeekToggle) {
      setHasDateTrait(true);
    } else {
      const hasDate = selected.some((trait: any) => trait?.dataType === 'D');
      setHasDateTrait(hasDate);
    }
  }, [selected, dateWeekToggle]);

  const checkText = (items: any) => {
    let value = false;
    let checkedArray: any = [];
    checkedArray =
      selected.length > 0 &&
      selected.filter((item: any, pos: any) => item?.traitID == items && item?.selected === true);
    value = checkedArray.length > 0 ? true : false;
    return value;
  };

  const onSearch = (event: any) => {
    event.preventDefault();
    const searchString = event.currentTarget.value.trim().toLowerCase();
    if (searchString.length > 0) {
      // We are searching. Filter the results.
      const optionsFiltered = options.filter((e: any) =>
        e.traitName.toLowerCase().match(searchString)
      );
      if (optionsFiltered.length > 0) {
        cropOptionsFiltered = optionsFiltered;
        setQuery(cropOptionsFiltered);
      } else {
        // if not found were sending empty
        cropOptionsFiltered = [];
        setQuery(cropOptionsFiltered);
      }
    } else {
      // if not found search key were reseting it
      cropOptionsFiltered = options;
      setQuery(cropOptionsFiltered);
    }
  };

  const handleNext = async (id: any, setShow: any, selected: any, currentStep: any) => {
    if (currentStep === 1) {
      // Persist only on proceed
      const filteredTraits = filterByReference(options, tempSelected);
      const addOrder = filteredTraits?.map((selections: any, index: any) => ({
        ...selections,
        traitID: selections?.traitID,
        columnLabel: selections?.columnLabel,
        selected: true,
        sortOrder: index
      }));
      setPrevTraits(addOrder);
      setOrderOfTrait([]);
      setOrder(addOrder);

      setSelected(tempSelected);
      setValue(tempSelected);
      setDropDownSelected(tempDropDownSelected);

      setCurrentStep(currentStep + 1);
    } else if (currentStep === 2) {
      console.log('here');

      const getVarieties = varieties?.Varieties;
      const TableID =
        getVarieties?.length > 0 &&
        getVarieties
          .map((getVarietiesGroup: any) =>
            order.map((nef: any) => ({
              ...nef,
              groupOfVaritey: getVarietiesGroup?.TrialLineId
            }))
          )
          .flat()
          .map((flattenedData: any, indexOfFlattenedData: any) => ({
            ...flattenedData,
            columnPos: indexOfFlattenedData + 1
          }));

      setInitialValueOfOrder([]);
      setVarietiesOrder([]);
      setInitialValueOfOrder1([]);
      await setOrderOfTrait(TableID);
      setReDraw(true);
      closeModal(id, setShow);
    }
  };

  const handlePrevious = (currentStep: number) => {
    setCurrentStep(currentStep - 1);
  };

  const onSortEnd = async ({ oldIndex, newIndex }: any) => {
    await setOrder((prevItem: any) => arrayMoveImmutable(prevItem, oldIndex, newIndex));
  };
  const onDropDownChange = async (evt: any, fieldSetName: any, fieldSetID: any) => {
    setTempDropDownSelected(fieldSetName);
    setIsLoadingTraits(true);
    try {
      const formDataForTrait: any = {
        DefaultTraitSetID: fieldSetID,
        cropCode: selectedCrop?.cropCode
      };
      const traits = await getTraitList(formDataForTrait);
      const updatedTraits = traits?.map((item: any) => ({
        ...item,
        selected: true
      }));
      setTempSelected(updatedTraits);
    } finally {
      setIsLoadingTraits(false);
    }
  };

  const truncateText = (text: string, maxLength: number) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }
    return text;
  };

  console.log('tempDropDownSelected', tempDropDownSelected);

  return (
    <div
      className={currentStep === 1 ? 'modal overlay' : 'orderData  modal overlay'}
      id={id}
      ref={impactRef21}>
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"> {currentStep === 1 ? `Select Trait(s)` : `Re Order`}</h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={(evt) => {
                if (currentStep === 1) {
                  setSelected(prevTraits);
                  setValue(prevTraits);
                }
                closeModal(id, setShow);
              }}></button>
          </div>
          <div className="modal-body">
            {currentStep === 1 && (
              <Fragment>
                <div className="measurement-standards mb-4">
                  <div className="row">
                    <div className="col-md-12 d-flex align-items-center justify-content-start">
                      {/*<select name="selectCrops" id="selectCrops"*/}
                      {/*        className='form-select form-select-date me-3'*/}
                      {/*        value={selectedDateFormat} onChange={handleChangeMain}*/}
                      {/*        disabled={isEmpty(selectedTrials) || selected.length === 0 ? true : false}*/}
                      {/*>*/}

                      <div className="form-check-switch float-end" style={{ paddingRight: '16px' }}>
                        <label className="switch">
                          <input
                            type="checkbox"
                            id="togBtn"
                            onChange={handleToggleChange}
                            checked={toggle ? true : false}
                          />
                          <div className="slider round">
                            <span>Metric</span>
                            <span>Imperial</span>
                          </div>
                          <div className="slider round">
                            <span>Metric</span>
                            <span>Imperial</span>
                          </div>
                        </label>
                      </div>

                      <div className="form-check-switch">
                        <label className="switch">
                          <input
                            type="checkbox"
                            id="switchMeasurement"
                            onChange={handleToggleChangeMeasurement}
                            checked={measurementType ? true : false}
                          />
                          <div className="slider">
                            <span>Comma</span>
                            <span>Point</span>
                          </div>
                          <div className="slider">
                            <span>Comma</span>
                            <span>Point</span>
                          </div>
                        </label>
                      </div>

                      <div className="form-check-switch mx-3">
                        <label className="switch">
                          <input
                            type="checkbox"
                            id="dateWeektogBtn"
                            checked={dateWeekToggle ? true : false}
                            onChange={handleDateWeekToggleChange}
                            //   disabled={orderOfTrait.length > 0 ? true : false}
                          />
                          <div className="slider">
                            <span>Date</span>
                            <span>Week</span>
                          </div>
                          <div className="slider">
                            <span>Date</span>
                            <span>Week</span>
                          </div>
                        </label>
                      </div>

                      {dateWeekToggle ? (
                        <DatePicker
                          id="yearPicker"
                          name="yearPicker"
                          onChange={onChangeYear}
                          picker="year"
                          className="me-3"
                          value={selectedYear}
                          style={{ borderRadius: '5px' }}
                          disabledDate={disabledDate}
                        />
                      ) : (
                        <select
                          name="selectCrops"
                          id="selectCrops"
                          className="form-select form-select-date"
                          style={{ fontSize: '14px' }}
                          value={selectedDateFormat}
                          onChange={handleChangeMain}>
                          <option value="" disabled>
                            Select DateFormat
                          </option>
                          {DATE_FORMAT_LIST.map((option) => {
                            return (
                              <option value={option.value} key={option.value}>
                                {option.label}
                              </option>
                            );
                          })}
                        </select>
                      )}
                      <div className="dropdown">
                        <button
                          className="btn dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false">
                          {truncateText(tempDropDownSelected, 21)}
                        </button>
                        <ul
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton1"
                          style={{ maxHeight: '300px', overflowY: 'auto' }}>
                          <li
                            onClick={(event) => {
                              onDropDownChange(event, 'Select Trait Set', 0);
                            }}>
                            <a className="dropdown-item" href="#">
                              Select Trait Set
                            </a>
                          </li>
                          {traitsetList?.map((item: any, traitListIndex: number) => (
                            <>
                              <li
                                onClick={(event) => {
                                  onDropDownChange(event, item?.fieldSetName, item?.fieldSetID);
                                }}
                                key={traitListIndex}>
                                <a className="dropdown-item" href="#">
                                  {item?.fieldSetName}
                                </a>
                              </li>
                            </>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </Fragment>
            )}

            <div className="col-md-6 d-flex align-items-center">
              <form className="nosubmit">
                <input
                  name="search"
                  placeholder={`Search`}
                  onKeyUp={(evt) => {
                    if (evt?.code !== 'Enter') {
                      onSearch(evt);
                    }
                  }}
                  value={cropSearchName}
                  onInput={(event) => {
                    const element = event.currentTarget as HTMLInputElement;
                    setCropSearchName(element.value);
                  }}
                />
              </form>
            </div>

            {currentStep === 1 ? (
              <Fragment>
                <div className="row">
                  <Fragment>
                    {varieties?.Varieties?.length === 0 && (
                      <div className="col-md-24">
                        <p className="alert alert-danger alert-text">
                          The selected Trial has no variety assigned to it
                        </p>
                      </div>
                    )}
                    {isLoadingTraits ? (
                      <div style={{ textAlign: 'center', padding: '50px 0' }}>
                        <Spin className="custom-spin" tip="Loading traits..." size="large" />
                      </div>
                    ) : (
                      <div className="row">
                        {Array.isArray(query) &&
                          query.length > 0 &&
                          query.map((data: any, index: any) => (
                            <div key={data.traitID} className="col-md-4">
                              <div
                                className="form-check trait-item"
                                onClick={() => selectedChanges(data)}
                                style={{
                                  listStyleType: 'none',
                                  visibility: 'inherit',
                                  opacity: '1'
                                }}>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={index.toString()}
                                  checked={tempSelected.some(
                                    (item: any) => item.traitID === data.traitID
                                  )}
                                  disabled
                                />
                                <label className="form-check-label" htmlFor={index.toString()}>
                                  {data?.traitName}
                                  {toggle && data?.uoMCodeImperial && ` (${data?.uoMCodeImperial})`}
                                  {!toggle && data?.uomCode && ` (${data?.uomCode})`}
                                </label>
                              </div>
                            </div>
                          ))}
                      </div>
                    )}
                  </Fragment>
                </div>
              </Fragment>
            ) : (
              <Fragment>
                <div id="container" className="sorting-items">
                  <SortableList
                    items={order}
                    toggle={toggle}
                    onSortEnd={onSortEnd}
                    lockAxis={'y'}
                    helperClass={'ca'}
                  />
                </div>
              </Fragment>
            )}
          </div>
          <div className="modal-footer">
            {currentStep !== 1 && (
              <button
                type="button"
                className="btn btn-success btn-back btn-success_custom btn-outline"
                onClick={(e) => handlePrevious(currentStep)}>
                Back
              </button>
            )}
            <button
              type="button"
              className="btn btn-success btn-success_custom float-end"
              onClick={(evt) => {
                handleNext(id, setShow, selected, currentStep);
              }}
              disabled={
                currentStep === 1 &&
                (filterByReference(options, tempSelected).length === 0 ||
                  varieties?.Varieties?.length === 0)
              }>
              {currentStep === 2 ? `Submit` : `Proceed`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkTraitSelectionModal;
